module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "con"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/img01_vii.png"
    }
  }), _c('br'), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/005#Book"
    }
  }, [_vm._v("How to Read This Book")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/006#Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/007#Pt01"
    }
  }, [_vm._v("PART ONE"), _c('br'), _vm._v("Voices from the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01"
    }
  }, [_vm._v("1 "), _c('strong', [_vm._v("Voices")]), _vm._v(" from the Storm of Death")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01Sec01"
    }
  }, [_vm._v("In memory of "), _c('em', [_vm._v("Claudette")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01Sec02"
    }
  }, [_vm._v("In memory of "), _c('em', [_vm._v("Mike")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01Sec03"
    }
  }, [_vm._v("In memory of "), _c('em', [_vm._v("Rob")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01Sec04"
    }
  }, [_vm._v("In memory of "), _c('em', [_vm._v("William and Ray")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/008#Ch01Sec05"
    }
  }, [_vm._v("In memory of "), _c('em', [_vm._v("Rob and Gene")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009#Ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 "), _c('strong', [_vm._v("Voices")]), _vm._v(" from the Storm of Terror")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009#Ch02Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Terry’s")]), _vm._v(" terror")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009#Ch02Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Julie’s")]), _vm._v(" terror")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/009#Ch02Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Don’s")]), _vm._v(" terror")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 "), _c('strong', [_vm._v("Voices")]), _vm._v(" from the Storm of Divorce")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Scott’s")]), _vm._v(" story")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Lisa’s")]), _vm._v(" story")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Phil’s")]), _vm._v(" story")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03Sec04",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jan’s")]), _vm._v(" story")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/010#Ch03Sec05",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ben’s")]), _vm._v(" story")]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011#Ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 "), _c('strong', [_vm._v("Voices")]), _vm._v(" from the Storm of Illness")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011#Ch04Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Denis and Kathy’s")]), _vm._v(" struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011#Ch04Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Danny’s")]), _vm._v(" struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/011#Ch04Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gary’s")]), _vm._v(" struggle")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-Chap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/012#Pt02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART TWO"), _c('br'), _c('strong', [_c('em', [_vm._v("Assurances from God’s Word")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Is God Really with Me?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“I will be with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There’s no need to fear.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God can be trusted.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05Sec04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God will protect you.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/013#Ch05Sec05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Victory is assured.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014#Ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Does God Really Care?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014#Ch06Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God loves unconditionally.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014#Ch06Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God knows our needs.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014#Ch06Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God will respond.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/014#Ch06Sec04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God comforts lovingly.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015#Ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Is There Life Beyond This One?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015#Ch07Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Storms are only temporary.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015#Ch07Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Life after death is assured.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015#Ch07Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New life on earth can be yours.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/015#Ch07Sec04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You have the power to overcome.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016#Ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Why Must We Suffer?")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016#Ch08Sec01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s okay to question God.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016#Ch08Sec02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God is not the source of your pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016#Ch08Sec03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("There are blessings in pain.")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-entry"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/016#Ch08Sec04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("You can adopt a new view of suffering.")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36490eb2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/004.vue
// module id = 72
// module chunks = 0